module.exports = __webpack_public_path__ + "img/twilio-full-logo.57713c78.png";